// metrics.jsx
export const metrics = {
    sessionId: null,
    sections: [], // { idx, size, tStart, tEnd, ok, status }
    startedAt: null,
};

export const startSession = () => {
    metrics.sessionId = crypto.randomUUID();
    metrics.sections = [];
    metrics.startedAt = performance.now();
};

export const recordSectionStart = (idx, size) => {
    metrics.sections.push({ idx, size, tStart: performance.now(), tEnd: null, ok: null, status: null });
};

export const recordSectionEnd = (idx, ok, status) => {
    const it = metrics.sections.find(s => s.idx === idx && s.tEnd === null);
    if (it) { it.tEnd = performance.now(); it.ok = ok; it.status = status; }
};

export const summarize = () => {
    const total = metrics.sections.length;
    const ok = metrics.sections.filter(s => s.ok).length;
    const avgLatencyMs = Math.round(
        metrics.sections.filter(s => s.tEnd).reduce((a, s) => a + (s.tEnd - s.tStart), 0) / Math.max(1, ok)
    );
    const sizeKB = metrics.sections.reduce((a, s) => a + (s.size || 0), 0) / 1024;
    return { sessionId: metrics.sessionId, total, ok, fail: total - ok, avgLatencyMs, sizeKB: Math.round(sizeKB) };
};